// Phase 6.C — 작업일정 / 공통 일정 sub-route.
// 시안 design/v3/SchedulePage.jsx SECTIONS[0] (id="common").

import { AlertBanner, EmptyState } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { findSection } from './data';
import { SectionCard } from './SectionCard';

export function ScheduleCommonRoute() {
  const isMobile = useViewport() === 'mobile';
  const section = findSection('common');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AlertBanner
        tone="info"
        message="공통 일정 — 전 직원 공통 매장 운영 안내. Phase 7 메일·SMS 인프라 도입 후 발송이 활성됩니다."
      />
      {section ? (
        <SectionCard section={section} isMobile={isMobile} />
      ) : (
        <EmptyState
          icon="list-checks"
          title="등록된 공통 일정이 없습니다"
          description="작업일정은 사장/직원이 직접 등록하는 회사별 격리 영역입니다. Phase 7 backend 도입 후 등록이 활성됩니다."
        />
      )}
    </div>
  );
}
